export function flexibilityGroup (fb) {
    return fb.group({
        begin: fb.group({
            plusOrMinus: [0]
        })
    });
}